export default "__VITE_ASSET__BHDsMF3x__"